import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, LocalService, ReceiptHtml, ReceiptTemplate, ReceiptType, Status, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-receipt-template',
  templateUrl: './receipt-template.component.html',
  styleUrls: ['./receipt-template.component.scss']
})
export class ReceiptTemplateComponent implements OnInit {
  ReceiptType = ReceiptType;
  lstSectionConfigKeys: string[] = ["receipt"]; maxBodyHeight = 0;
  mandatoryLanguages = []; wrapper: KeyValues5; isConfigurable = false; isFixedGeneral = false;
  @Input() businessId: string | undefined = undefined; @Input() receiptType: ReceiptType = ReceiptType.None;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.mandatoryLanguages.push(this.languageManagementService.getEnglishLanguageId());
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (ReceiptType[this.receiptType].startsWith('Fix_Direct')) {
      this.isConfigurable = true;
    }

    if (ReceiptType[this.receiptType].startsWith('Fix_Direct')
      && (ReceiptType[this.receiptType].endsWith('Gen') || ReceiptType[this.receiptType].endsWith('XXmm'))) {
      this.isFixedGeneral = true;
    }

    this.billingManagementService.getReceiptTemplate(this.receiptType, this.businessId, true).subscribe(result => {
      if (ReceiptType[this.receiptType].startsWith('Fix_Direct')) {
        result = result as ReceiptHtml | undefined;
        this.wrapper = result ? {
          key: result.Id,
          v1: '',
          v2: '',
          v3: this.receiptType.toString(),
          v4: result.HTML ?? '',
          v5: ''
        } as KeyValues5 : {
          key: '',
          v1: '',
          v2: '',
          v3: this.receiptType.toString(),
          v4: '',
          v5: ''
        } as KeyValues5;
      } else {
        result = result as ReceiptTemplate | undefined
        this.wrapper = result ? {
          key: result.Id,
          v1: result.Styles,
          v2: result.Width ? result.Width.toString() : '',
          v3: this.receiptType.toString(),
          v4: result.HTML ?? '',
          v5: this.businessId
        } as KeyValues5 : {
          key: '',
          v1: '',
          v2: '',
          v3: this.receiptType.toString(),
          v4: '',
          v5: this.businessId
        } as KeyValues5;
      }
    });
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.billingManagementService.saveReceiptTemplate(this.wrapper).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.wrapper.key = result.id;
        this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      }
    });
  }

  onGetReceiptTypeName(): string {
    return ReceiptType[this.receiptType];
  }
}
